<template>
    <v-dialog v-model="isOpen" persistent width="536px" class="admin-offers-edit">
        <v-card class="admin-offers-edit__card" >
            <v-card-text class="admin-offers-edit__card-title px-0">
                {{isCreate ? "Crear Usuario: " : "Editar Usuario: "}} <br> 
            </v-card-text>
            <v-card-text>
                <v-text-field
                    label="id"
                    v-if="payment && payment.id"
                    :value="payment && payment.id ? payment.id : 'null'"
                    readonly
                    hide-details
                    dense
                    filled
                    class="mx-auto my-3"
                >
                    <template v-slot="{label}">
                        <v-label class="admin-offers-edit__card-message-label">
                            {{label}}
                        </v-label>
                    </template>
                </v-text-field>
                <v-text-field
                    :label="`Usuario (id: ${payment && payment.id ? payment.id : 'null'})`"
                    :value="payment && payment.email ? payment.email : ''"
                    hide-details
                    dense
                    filled
                    class="mx-auto my-3"
                >
                    <template v-slot="{label}">
                        <v-label class="admin-offers-edit__card-message-label">
                            {{label}}
                        </v-label>
                    </template>
                </v-text-field>
                <v-text-field
                    label="Nombre"
                    v-model="payment.name"
                    hide-details
                    dense
                    filled
                    class="mx-auto my-3"
                >
                    <template v-slot="{label}">
                        <v-label class="admin-offers-edit__card-message-label">
                            {{label}}
                        </v-label>
                    </template>
                </v-text-field>
                <v-text-field
                    label="Telefono"
                    v-model="payment.phone"
                    hide-details
                    dense
                    filled
                    class="mx-auto my-3"
                >
                    <template v-slot="{label}">
                        <v-label class="admin-offers-edit__card-message-label">
                            {{label}}
                        </v-label>
                    </template>
                </v-text-field>
                <v-select
                    label="Metodo de login (OBLIGATORIO)"
                    v-model="payment.login"
                    :items="itemsLogin"
                    item-value="value"
                    item-text="desc"
                    hide-details
                    dense
                    filled
                    class="mx-auto my-3"
                
                >
                    <template v-slot="{label}">
                        <v-label class="admin-offers-edit__card-message-label">
                            {{label}}
                        </v-label>
                    </template>
                </v-select>
                <v-text-field
                    label="Experiencia"
                    v-model="payment.experience"
                    hide-details
                    dense
                    filled
                    class="mx-auto my-3"
                >
                    <template v-slot="{label}">
                        <v-label class="admin-offers-edit__card-message-label">
                            {{label}}
                        </v-label>
                    </template>
                </v-text-field>
                
                <v-select
                    label="Rol (OBLIGATORIO)"
                    v-model="payment.role"
                    :items="itemsRol"
                    item-value="value"
                    item-text="desc"
                    hide-details
                    dense
                    filled
                    class="mx-auto my-3"
                >
                    <template v-slot="{label}">
                        <v-label class="admin-offers-edit__card-message-label">
                            {{label}}
                        </v-label>
                    </template>
                </v-select>

                <v-select
                    label="Estatus (OBLIGATORIO)"
                    v-model="payment.status"
                    :items="itemsStatus"
                    item-value="value"
                    item-text="desc"
                    hide-details
                    dense
                    filled
                    class="mx-auto my-3"
                >
                    <template v-slot="{label}">
                        <v-label class="admin-offers-edit__card-message-label">
                            {{label}}
                        </v-label>
                    </template>
                </v-select>

              
            </v-card-text>
            <v-card-actions class="admin-offers-edit__card d-flex justify-end align-center mx-0 px-0">
                <v-btn
                    @click="closeDialog"
                    outlined
                    color="#3BADFF"
                    dark
                    :disabled="isLoading"
                >
                    Cancelar
                </v-btn>
                <v-btn
                    :loading="isLoading"
                    @click="updateItem"
                    outlined
                    color="#3BADFF"
                    dark
                    class="px-5"
                >
                    Actualizar
                </v-btn>

            </v-card-actions>
        </v-card>
    </v-dialog>    
</template>
<script>
import { datetime, currentImg, handleTxt } from "@/libs/mixins";
import { packsDesc } from "@/config/fixtures";
import { mapGetters, mapActions } from "vuex";


export default {
    name: "AdminPaymentForm",
    props: {
        payment: {
            default: null
        },
        dialog: {
            default: false,
            type: Boolean
        },
        isCreate: {
            default: false,
            type: Boolean
        }
    }, 
    mixins: [datetime, currentImg, handleTxt],
    data() {
        return {
            isLoading: false,
            isOpen: false,
            errors: false,
            organization: null,
            organizationItems: [],
            itemsCurrency: ["CLP", "USD"],
            userItems: [],
            search: null,
            file: null,
            itemsStatus: [
                { desc: "Activo", value: "active" },
                { desc: "Inactivo", value: "inactive" }
            ],
            itemsRol: [
                { desc: "Candidato", value: "candidate" },
                { desc: "Organizacion", value: "organization" },
                { desc: "Administrador", value: "sysadmin" },
            ],
            itemsLogin: [
                { desc: "Normal", value: "normal" },
                { desc: "Social", value: "social" },
            ],
            item: {
                access: "--",
                email: "",
                experience: 0,
                id: 0,
                login: "",
                name: "",
                phone: "",
                role: "",
                status: ""
            },
            user: null,
        };
    },
    computed: {
        ...mapGetters("users", ["getRole", "getType"]),
        packsDesc() {
            return [...packsDesc];
        }
    },
    watch: {
        errors() {
            console.info("errors: ", this.errors);
        },
        dialog() {
            this.isOpen = this.dialog || false;
        },
        "item.total"() {
            this.item.total = parseInt(this.item.total);
        },
        async organization() {
            this.userItems = [];
            this.bucket = {
                args: null,
                current: 0,
                max: 0,
                expiredAt: ""
            };
            const users = await this.getUsersByOrg(this.organization.id);
            console.log(users);
            this.userItems = users;
            users.forEach(u => {
                if (u.organization.bucketId !== null) {
                    this.bucket = { ...u.organization.bucket, expiredAt: this.getDate(u.organization.bucket.expiredAt) };
                }
            });
        },
        async isCreate() {
        },
        async payment() {
            this.isLoading = true;
            if (typeof this.payment === "object" && !this.isCreate) {
                this.user = { ...this.payment };
            } else {
                this.user = { ...this.payment };
                this.item = { ...this.payment };
                console.log("error");
                this.isLoading = false;
            }
            this.isLoading = false;
        }
    },
    methods: {
        ...mapActions("organizations", ["getOrganizations"]),
        ...mapActions("users", ["getUsersByOrg", "updateAdmin"]),
        closeDialog() {
            this.isLoading = false;
            this.organizationItems = [];
            this.userItems = [];
            this.file = null;
            this.item = {
                access: "--",
                email: "",
                experience: 0,
                id: 0,
                login: "",
                name: "",
                phone: "",
                role: "",
                status: ""
            };
            this.organization = null;
            this.user = null;
            this.$emit("close");
        },
        filterText(item, search, value) {
            return  value !== null &&
                search !== null &&
                (this.normalized(item.id).includes(this.normalized(search)) || 
                this.normalized(item.name).includes(this.normalized(search)));
        },
        async updateItem() {
            try {
                this.isLoading = true;
                
                const updatedItem = await this.updateAdmin({ ...this.payment });
                this.closeDialog();
            } catch (error) {
                console.error(error);
            }
        },
    }
};
</script>
